import SwrFetchData from './SwrFetchData';

export default SwrFetchData;
